import { useQuery } from "react-query";
import { key_EsuraApiConnectionProperties } from "../utils/constants";
import { getEsuraApiConnectionProperties } from "../services/esuraApiConnectionProperties";

export const useEsuraApiConnectionProperties = () =>
  useQuery(
    [key_EsuraApiConnectionProperties],
    () => getEsuraApiConnectionProperties(),
    // `retry: false` porque a ausência de configuração é uma resposta de erro
    // legítima: sem isto o ecrã ficava preso no spinner durante 3 tentativas,
    // tanto na primeira visita como logo a seguir a remover a configuração.
    { refetchOnWindowFocus: false, retry: false }
  );
